import React from 'react';
import { RootState } from 'reducer';
import Button from 'seedly-component-library/button-new';
import Dialog from 'seedly-component-library/dialog';
import { Reward, RewardFilter } from 'entity/reward/rewardTypes';
import { closeRewardModal, openRewardModal } from 'dispatcher/modalDispatcher';
import { setRewardAsClaimed } from 'entity/reward/rewardRedux';
import ModalActions from 'reducer/modalRedux';

import { useDispatch, useSelector } from 'react-redux';
import SuccessLottie from './SuccessLottie';

interface OwnProps {
  reward: Reward;
  setSelectedTab: (param: RewardFilter) => void;
}

const RedeemRewardSuccessModal = (props: OwnProps) => {
  const { reward, setSelectedTab } = props;

  const dispatch = useDispatch();

  const profile = useSelector((state: RootState) => state.profile.user);
  const isOpen = useSelector(
    (state: RootState) => state.modal.isClaimRewardSuccessModalOpen,
  );
  const claimedReward = useSelector(
    (state: RootState) => state.reward.claimedReward,
  );

  if (!reward) return null;

  return (
    <Dialog
      isOpen={isOpen}
      onCloseClick={() => {
        dispatch(ModalActions.setClaimRewardSuccessModal(false));
      }}
      isMobileFullHeight={false}
    >
      <div className="flex flex-col w-full gap-4 items-center">
        <SuccessLottie />
        <p className="text-center">
          Yay! You’ve successfully redeemed{' '}
          <span className="font-bold">{reward.title}</span>.
        </p>
        <p>Remaining credits: {profile?.creditsCount?.toLocaleString()}</p>
        <Button
          onClick={() => {
            dispatch(ModalActions.setClaimRewardSuccessModal(false));
            dispatch(closeRewardModal());
            dispatch(setRewardAsClaimed(claimedReward.reward));
            dispatch(
              openRewardModal(claimedReward.rewardId, claimedReward.claimId),
            );
            setSelectedTab('my-reward');
          }}
        >
          View Reward
        </Button>
      </div>
    </Dialog>
  );
};

export default RedeemRewardSuccessModal;
